
import version from 'consts:version';
import env from 'consts:environment';
import environmentName from 'consts:environment_name';

import IMDApp from './index';
import Recovery from './Recovery.svelte';

import { init } from '~/main';
import { init as initErrorTracking } from '~/error-tracking';
import Events from '~/events';
import { preventPageExit } from '~/protect';
import FacilitiesService from '~/service/facilities';

export async function bootstrap () {

  try {
    await bootstrapThrows();
  } catch (e) {
    console.error(e);
    Events.dispatchEvent('error:fatal', e);
  }
}

export async function bootstrapThrows () {

  await initErrorTracking(Events)(
    Object.assign(
      { version },
      env
    )
  );

  injectRecovery();

  preventPageExit(document);

  const imdApp = new IMDApp();

  // Test Recovery
  // const r = new Response(undefined, {
  //   headers: { 'content-type': 'text/html' },
  //   size: 555,
  //   status: 200,
  //   statusText: 'ok',
  //   url: 'http://localhost:8081/ainoa-10/api/stores?lang=fi',
  // });
  // throw new JsonParseError(r, document.body.parentElement.innerHTML);

  return await init(imdApp, {
    env,
    service: {
      facilities: new FacilitiesService()
    }
  });
}

function injectRecovery () {
  const target = document.body;
  const anchor = addAnchor(target, 'recovery');
  new Recovery({
    target,
    anchor,
  });
}

// addAnchor :: Node -> Node
export const addAnchor = (parent, name) => {
  const slot = document.createElement('div');
  slot.setAttribute('data-anchor', name);
  parent.appendChild(slot);
  return slot;
};

if (environmentName != 'test') {
  bootstrap();
}
